import { Response } from "../types/Response.interface";
import { apiClient } from "./apiClient";
const popupDetail = async (slug: string) => {

    const res: Response = await apiClient.get(
        `/api/v1/rets/${slug}?fields=BedroomsTotal,ParkingTotal,BathroomsTotalInteger,UnparsedAddress,Municipality,ListingKey,ListPrice,Slug,Lock`
      );
    
      if (res.ok) {
        return {
            Image: `https://api.bungalowfinder.ca/cdn/images/${res.data.Ml_num}/photo_1.webp`,
            ...res.data,
        };
      }
    
      return {
        notFound: true,
        props: {},
      };
};

export default popupDetail;
